var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.hasText ? 'see-more-btn' : 'see-more-btn-no-button'},[(_vm.hasText)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e(),_c('img',{staticClass:"step-btn-icon",attrs:{"src":require("../../assets/registration/icons/arrow-down.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }